import axios from 'axios'
import store from 'store'
import { notification } from 'ant-design-vue'
import { BASE_URL } from '@/config'

const CancelToken = axios.CancelToken
const source = CancelToken.source()

// export const requestInterceptor = config => {
//   config.cancelToken = source.token
//   return config
// }

const apiClient = axios.create({
  // baseURL: BASE_URL,
  baseURL: BASE_URL,
  // baseURL: 'https://pulih-api-prod.digitala.id:3002/',
  // baseURL: 'http://206.189.95.69:3001/',
  // baseURL: 'http://206.189.95.69:3001',
  // baseURL: BASE_URL,
  timeout: 60000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

// apiClient.interceptors.request.use(requestInterceptor)

apiClient.interceptors.request.use((request) => {
  const accessToken = store.get('accessToken')
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }
  return request
})

apiClient.interceptors.response.use(undefined, (error) => {
  // Errors handling
  const errorList = error?.response?.data?.errorList
  console.error('API request failed', errorList || error.message)
  if (error && error.response && error.response.data) {
    if (Array.isArray(errorList)) {
      errorList.forEach((element) => {
        if (
          element !== 'invalid email' &&
          element !== 'invalid password' &&
          element !== 'Data target tidak ditemukan' &&
          element !== 'Data code tidak ditemukan'
        ) {
          notification.warning({
            message: 'Gagal',
            description: element,
            duration: 5,
          })
        }
      })
    } else {
      notification.warning({
        message: 'Gagal',
        description:
          'Permintaan gagal dengan alasan: ' + (errorList || error.message),
        duration: 5,
      })
    }
  } else {
    notification.warning({
      message: 'Gagal',
      description: 'Tidak dapat terhubung ke server dengan alasan: ' + error,
      duration: 5,
    })
  }

  return Promise.reject(error)
})

export default apiClient
export { source }
